module.exports = __webpack_public_path__ + "static/media/locationIcon.42537f4c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Comp/img/locationIcon.svg
// module id = 44
// module chunks = 0